var _path, _path2, _g, _path3, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.43671 17.5251H4.27136C2.18783 17.5251 0.492188 15.8295 0.492188 13.7443V4.2567C0.492188 2.17147 2.18783 0.474976 4.27136 0.474976H8.42733C10.5126 0.474976 12.2091 2.17147 12.2091 4.2567V5.05124C12.2091 5.40418 11.9226 5.69062 11.5697 5.69062C11.2167 5.69062 10.9303 5.40418 10.9303 5.05124V4.2567C10.9303 2.87564 9.80754 1.75374 8.42733 1.75374H4.27136C2.89285 1.75374 1.77095 2.87564 1.77095 4.2567V13.7443C1.77095 15.1245 2.89285 16.2464 4.27136 16.2464H8.43671C9.81095 16.2464 10.9303 15.1279 10.9303 13.7536V12.9497C10.9303 12.5968 11.2167 12.3103 11.5697 12.3103C11.9226 12.3103 12.2091 12.5968 12.2091 12.9497V13.7536C12.2091 15.8338 10.516 17.5251 8.43671 17.5251Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6_309",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 8,
    width: 12,
    height: 2
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4563 8.3606H18V9.63936H6.4563V8.3606Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6_309)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3607 9.63936H7.09568C6.74274 9.63936 6.4563 9.35292 6.4563 8.99998C6.4563 8.64704 6.74274 8.3606 7.09568 8.3606H17.3607C17.7137 8.3606 18.0001 8.64704 18.0001 8.99998C18.0001 9.35292 17.7137 9.63936 17.3607 9.63936Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6_309",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 5,
    width: 4,
    height: 8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2256 5.87573H17.9999V12.1253H14.2256V5.87573Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6_309)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8648 12.1253C14.7011 12.1253 14.5365 12.063 14.4121 11.9369C14.1631 11.6862 14.164 11.2821 14.4138 11.0332L16.4547 8.99996L14.4138 6.96758C14.164 6.71865 14.1623 6.31456 14.4121 6.06392C14.661 5.81329 15.0651 5.81329 15.3157 6.06222L17.8119 8.54728C17.9329 8.66663 18.0003 8.83031 18.0003 8.99996C18.0003 9.16961 17.9329 9.33329 17.8119 9.45264L15.3157 11.9386C15.1913 12.063 15.0276 12.1253 14.8648 12.1253Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.3596693d0daf0a1ad8a64a8c9ef66b19.svg";
export { ForwardRef as ReactComponent };